export const HomeEndpoints = {
    getDonee: (id: string) => `/home/donee/${id}`,
};
